import { lightColorPalette } from '@linearb/linui-common';
import styled from 'styled-components';

export const StyledTotal = styled.div`
  border-right: 1px solid ${lightColorPalette.lbTextSubdued};
  margin-right: 1rem;
  padding-right: 1rem;
  color: ${lightColorPalette.lbGreyDark};
  font-size: 1.3rem;
`;

export const StyledFiltersRow = styled.div`
  display: flex;
  align-items: center;
  &:not(:first-child) {
    margin-top: 2rem;
  }
`;

export const StyledSearch = styled.div`
  margin-left: auto;
  width: 20%;
`;

export const StyledHeader = styled.header``;
